/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as TYPES from './action-types';
import axios from 'axios';
import * as serviceEndPoint from '../../../../../../SharedModules/services/service';

export const resetRquestedClaimAction = (payload) => {
  return {
    type: TYPES.RESET_REQUEST_CLAIM_DATA,
    payload,
  };
};
export const setErrorMessage = (payload) => {
  return {
    type: TYPES.SET_ERROR_MESSAGES,
    payload,
  };
};
export const setSearchErrorMessage = (payload) => {
  return { type: TYPES.SET_SEARCH_ERROR_MSG, payload };
};
export const setPlanTypeAction = (payload) => {
  return {
    type: TYPES.SET_PLAN_TYPE,
    payload,
  };
};

export const setSelectTypeAction = (payload) => {
  return {
    type: TYPES.SET_SELECT_TYPE,
    payload,
  };
};

export const setActionsTypeAction = (payload) => {
  return {
    type: TYPES.SET_ACTIONS_TYPE,
    payload,
  };
};

export const setClaimSelectedNDCTab = (payload) => {
  return {
    type: TYPES.CLAIM_SELECTED_NDC_TAB,
    payload,
  };
};

export const handleSelectChangeFilter = (e, name, value) => {
  return (dispatch, getState) => {
    const currentFilter = {
      ...getState().sharedState.claim.claimSelectByFilter,
    };

    currentFilter[name] = e
      ? e.target.value === -1
        ? null
        : e.target.value
      : value;
    dispatch(setClaimSelectByFilter(currentFilter));
  };
};

export const setClaimSelectByFilter = (payload) => {
  return {
    type: TYPES.CLAIM_SELECT_BY_FILTER,
    payload,
  };
};

export const handleTextFieldChangeFilter = (e, name) => {
  return (dispatch, getState) => {
    const currentFilter = {
      ...getState().sharedState.claim.claimSelectByFilter,
    };
    currentFilter[name] = e.target.value;
    dispatch(setClaimSelectByFilter(currentFilter));
  };
};

export const setReabteProgramData = (payload) => {
  return {
    type: TYPES.OMITTED_CLAIM_TABLE_REBATE_PROGRAM_DATA,
    payload,
  };
};

export const setUserDefault = (payload) => {
  return {
    type: TYPES.DELETE_CHECK_LOG_USERDEFAULT,
    payload,
  };
};

export const resetRequestedClaimStore = () => {
  return {
    type: TYPES.RESET_REQUEST_CLAIM_DATA,
  };
};

export const setDrugFamilyCode = (payload) => {
  return {
    type: TYPES.SET_DRUG_FAMILY_DETAILS,
    payload,
  };
};
export const setDrugFamilyRow = (payload) => {
  return {
    type: TYPES.SET_SELECTED_DRUG_FAMILY_ROW,
    payload,
  };
};
export const setDrugFAMILYProcessResponse = (payload) => {
  return {
    type: TYPES.DRUG_FAMILY_PROCESS_RESPONSE,
    payload,
  };
};

export const getRebateProgramCode = (values) => async (dispatch) => {
  try {
    const response = await axios.post(
      `${serviceEndPoint.GET_ALL_REBATE_PROGRAMS}`,
      { planType: values }
    );
    if (response.data && response.data.data && response.data.data.length > 0) {
      let newData = [];
      response.data.data.forEach((item) => {
        newData.push({
          label: `${item.rebateProgramCd} ${item.shortDescr}`,
          value: item.rebateProgramCd,
          ...item,
        });
      });
      dispatch(setReabteProgramData(newData));
    } else {
      dispatch(setReabteProgramData([]));
    }
  } catch (e) {
    dispatch(setReabteProgramData([]));
  }
};
export const getDrugFamilyCode = (body) => async (dispatch) => {
  try {
    const response = await axios.post(
      `${serviceEndPoint.GET_DRUG_FAMILY_DETAILS}`,
      body
    );

    dispatch(setDrugFamilyCode(response.data));
    if (response.data && response.data.length > 0) {
      dispatch(setDrugFamilyCode(response.data));
    }
  } catch (e) {
    dispatch(setDrugFamilyCode([]));
  }
};
export const ProcessDrugFamilyCode = (body) => async (dispatch) => {
  try {
    const response = await axios.post(
      `${serviceEndPoint.PROCESS_DRUG_FAMILY_DETAILS}`,
      body
    );
    setDrugFAMILYProcessResponse(response);
  } catch (e) {}
};
